// extracted by mini-css-extract-plugin
export var headlineWrapper = "leistungen-module--headline-wrapper--A9qV7";
export var spinAround = "leistungen-module--spinAround--3GIvm";